module.exports = __webpack_public_path__ + "static/media/punto_ticket.28bff283.png";